import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { LOYALTY_REWARDS } from "../../utils/constant";

const Banner = () => {

  const heading = useSelector((state) => state.header.heading);
    const profileData = useSelector((state) => state.auth.profileData);
const tiers  = localStorage.getItem("customerTier")

  return (
    <section className="home-banner mb-15">
      <div className="home-banner-left">
        <h1>
          {tiers === "Silver" ? "Get 20K Points" : tiers=== "Gold" ? "Get 30K Points" : tiers=== "Platinum" ? "Get 50K Points" : tiers=== "Founder Club" ? "Get 80K Points" : "Get 0 Points" } <span>as a welcome offer</span>
        </h1>
        <div>
          {heading === LOYALTY_REWARDS ? (
            <Link to="/claim-now" className="btn btn-gold mb-08">
              <span>Claim Now</span>
            </Link>
          ) : (
            <></>
          )}
        </div>
        <p style={{"font-size":"0.75rem"}}>100 Points = ₹1</p>
      </div>
      <div className="home-banner-right">
        <div className="home-banner-right-box">
          <img src="/images/giftbox_blue.png" alt="" className="shake" />
        </div>  
      </div>
    </section>
  );
};

export default Banner;
